import {gql} from "@apollo/client";
import {useEffect} from "react";
import {UseFormReturn} from "react-hook-form";
import {useLazyQuery$} from "../../../../graphqlsupport";
import {TreatmentHoldInput} from "./TreatmentHoldFormModal";
import {fromApiTreatmentHold} from "./treatmentHoldDefaults";


export type LatestTreatmentHoldData = {
    guid: string;
    authorizationGuid: string;
} & TreatmentHoldInput;

const AUTHORIZATION_LATEST_OFFERED_HOURS = gql`
query treatmentHoldByAuth($authorizationGuid: UUID) {
    treatmentHoldByAuth(authorizationGuid: $authorizationGuid) {
        guid
        authorizationGuid
        holdType
        requestReason
        requestReasonOther
        dateHoldDiscussedWithFamily
        providerResumeServices
        canProviderResumeServices
        familyNotifiedUnableToResume
        startDate
        endDate
        comments
        dateOfLastTreatment
        dateOfMostRecentAppointment
        dateOfLastFullScheduleOffer
        offeredParaprofessionalHours
        offeredMidLevelHours
        offeredHighLevelHours
        offeredGroupCareHours
        serviceType
        providerRequestForCcsConsultation
        reasonForConsultation
        summaryOfStepsTaken
        providerContactName
        providerContactEmail
        providerContactPhone
    }
}
`;

function useLatestTreatmentHoldInput$(authorizationGuid: string) {
    const {execute, data, isRunning$, error} = useLazyQuery$<{
        authorizationGuid: string
    }, {
        treatmentHoldByAuth: LatestTreatmentHoldData
    }>(AUTHORIZATION_LATEST_OFFERED_HOURS, {
        authorizationGuid,
    });

    return {
        execute,
        data,
        isRunning$,
        error
    };
}


export function useLatestTreatmentHoldInput(showModal: boolean, methods: UseFormReturn<TreatmentHoldInput>, authorizationGuid: string) {
    const {execute, data, isRunning$, error,} = useLatestTreatmentHoldInput$(authorizationGuid);
    useEffect(() => {
        if (showModal && authorizationGuid != null) {
            execute({
                authorizationGuid,
            });
        }
    }, [authorizationGuid, showModal, execute]);
    useEffect(() => {
        if (data?.treatmentHoldByAuth != null) {
            methods.reset({
                ...methods.getValues(),
                ...fromApiTreatmentHold(data.treatmentHoldByAuth),
            });
        }
    }, [data, methods]);
    return {
        isRunning$,
        error,
    };
}
